// Toolbar visibility management

export function showTools(timestamp) {
    const toolbar = document.getElementById(`toolbar-${timestamp}`); 
    if (toolbar) {
        toolbar.classList.remove('hidden');
        toolbar.classList.add('visible');
    }
}

export function resetTools() {
    const toolbar = document.getElementById('toolbar'); 
    if (toolbar) {
        toolbar.classList.remove('visible');
        toolbar.classList.add('hidden');
        const thumbsup = document.getElementById('thumbsup');
        const thumbsdown = document.getElementById('thumbsdown');
        if (thumbsup) thumbsup.innerHTML = '<span class="material-symbols-rounded notranslate">thumb_up</span>';
        if (thumbsdown) thumbsdown.innerHTML = '<span class="material-symbols-rounded notranslate">thumb_down</span>';
        if (thumbsup) thumbsup.removeAttribute("hidden");
        if (thumbsdown) thumbsdown.removeAttribute("hidden");
    }
    const footerNote = document.getElementById('footer-note');
    if (footerNote) footerNote.classList.remove('visible');
}
